import { render, staticRenderFns } from "./aboutClients.vue?vue&type=template&id=4c4a6acf&scoped=true&"
import script from "./aboutClients.vue?vue&type=script&lang=js&"
export * from "./aboutClients.vue?vue&type=script&lang=js&"
import style0 from "./aboutClients.vue?vue&type=style&index=0&id=4c4a6acf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a6acf",
  null
  
)

export default component.exports